'use client';

import * as React from 'react';
import { FileUpload } from './file-upload';
import { useUploadImage } from '@/lib/api/images';

const MIME_IMAGE = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
const IMAGE_ACCEPT = MIME_IMAGE.join(',');

interface ImageUploadProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onInput'> {
  url: string | undefined | null;
  onImageAvailable: (url: string) => void;
}

export const ImageUpload = ({
  url: originalUrl,
  onImageAvailable,
  className,
  ...props
}: ImageUploadProps) => {
  const { mutate: uploadImage, isPending, isError, error } = useUploadImage();

  const handleFileSelect = (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    uploadImage(formData, {
      onError: (error) => {
        console.error(error);
      },
      onSuccess: (data) => {
        onImageAvailable(data.file.url);
      },
    });
  };

  return (
    <FileUpload
      accept={IMAGE_ACCEPT}
      isLoading={isPending}
      error={isError ? (error?.message || 'Failed to upload image') : null}
      loadingText="Uploading image..."
      onFileSelect={handleFileSelect}
      className={className}
      {...props}
    />
  );
};
